"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
const react_1 = __importDefault(require("react"));
const core_1 = require("@material-ui/core");
const Edit_1 = __importDefault(require("@material-ui/icons/Edit"));
const Videocam_1 = __importDefault(require("@material-ui/icons/Videocam"));
const AddPhotoAlternate_1 = __importDefault(require("@material-ui/icons/AddPhotoAlternate"));
const Mic_1 = __importDefault(require("@material-ui/icons/Mic"));
const LocationOn_1 = __importDefault(require("@material-ui/icons/LocationOn"));
const CropFree_1 = __importDefault(require("@material-ui/icons/CropFree"));
const FileCopy_1 = __importDefault(require("@material-ui/icons/FileCopy"));
const Icons = {
    fileupload: react_1.default.createElement(FileCopy_1.default, null),
    imageupload: react_1.default.createElement(AddPhotoAlternate_1.default, null),
    videoupload: react_1.default.createElement(Videocam_1.default, null),
    audioupload: react_1.default.createElement(Mic_1.default, null),
    barcode: react_1.default.createElement(CropFree_1.default, null),
    signature: react_1.default.createElement(Edit_1.default, null),
    location: react_1.default.createElement(LocationOn_1.default, null),
    aggregateSelector: react_1.default.createElement(LocationOn_1.default, null),
};
const getIcon = (type) => {
    return Icons[type] || null;
};
const createLabel = {
    fileupload: 'File',
    imageupload: 'Image',
    videoupload: 'Video',
    audioupload: 'Audio',
    barcode: 'Barcode',
    signature: 'Signature',
    location: 'Location',
    aggregateSelector: 'Item',
};
const EditComponentButton = props => {
    const { mode, type, onClick, readOnly } = props;
    return (react_1.default.createElement(core_1.FormControl, { component: "fieldset", style: { marginTop: 8, marginBottom: 5 } },
        react_1.default.createElement(core_1.Button, { disabled: readOnly, variant: "contained", startIcon: getIcon(type), onClick: onClick },
            mode,
            " ",
            createLabel[type])));
};
exports.default = EditComponentButton;
//# sourceMappingURL=EditComponentButton.js.map